import _isString from "lodash-es/isString";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import izitoast from 'izitoast';
import { formatAlertMessage } from '../../util/formatters';
import removeNode from '../../util/removeNode';
import { getStatusIcon, NotificationServiceIcons } from './icons';
import { NotificationType } from './types';
var DEFAULT_TIMEOUT = 5000; // 5 second timeout on success / info toasts

var DEFAULT_MESSAGE_LENGTH = 280;
var DEFAULT_POSITION = 'topRight';
var D3_NOTIFICATION_CLASS = 'toaster-container';
var D3_MODAL_TARGET_CLASS = '.swal2-popup';
var defaultIziToastSettings = {
  timeout: DEFAULT_TIMEOUT,
  pauseOnHover: true,
  displayMode: 1,
  position: DEFAULT_POSITION,
  target: '',
  layout: 2,
  class: D3_NOTIFICATION_CLASS,
  // it is must, to apply d3 styles on toasts.
  message: ''
};

var defaultD3ToastSettings = _objectSpread(_objectSpread({}, defaultIziToastSettings), {}, {
  closeButtonText: 'Close',
  readMoreButtonText: 'Read More',
  defaultErrorTimeout: 0,
  defaultSuccessTimeout: 0
});

var toastReadMoreTemplate = function toastReadMoreTemplate(label) {
  return "<button type=\"button\" class=\"read-more-btn btn btn-link btn-xs\">\n  ".concat(label, "\n</button>");
};
/**
 *  Notification Service to render notifications
 *  Vendor Styles and Theme styles are loaded from notificationStyles.js
 */


var NotificationService = /*#__PURE__*/function () {
  function NotificationService() {
    _classCallCheck(this, NotificationService);

    this.toaster = izitoast;
    this.defaultOptions = void 0;
    this.configureNotifications();
  }

  _createClass(NotificationService, [{
    key: "configureNotifications",
    value: function configureNotifications() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.defaultOptions = _objectSpread(_objectSpread({}, defaultD3ToastSettings), {}, {
        onOpening: function onOpening(settings, toast) {
          return _this.onOpening(settings, toast);
        },
        onOpened: function onOpened(settings, toast) {
          if (settings.close) {
            toast.focus();
          }
        }
      }, options);
      this.toaster.settings(this.defaultOptions);
    }
  }, {
    key: "parseToastConfig",
    value: function parseToastConfig() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // @ts-ignore TODO - Fix typings in this module
      var notificationOptions = {};

      if (options !== null) {
        if (typeof options === 'string') {
          notificationOptions = {
            message: options
          };
        } else if (_typeof(options) === 'object') {
          var formattedMessageArray; // @ts-ignore TODO - Fix typings in this module

          notificationOptions = options;
          var _notificationOptions = notificationOptions,
              _message = _notificationOptions.message,
              defaultText = _notificationOptions.defaultText,
              msgArray = _notificationOptions.msgArray;
          var defaultMessage = defaultText || this.defaultOptions.defaultText || '';

          if (_message && _typeof(_message) === 'object') {
            formattedMessageArray = formatAlertMessage(_message, defaultMessage);
          } else if (_message && typeof _message === 'string') {
            formattedMessageArray = [_message];
          } else if (_message === undefined || _message === null) {
            formattedMessageArray = [defaultMessage];
          } // if there are extra messages then add them


          if (Array.isArray(msgArray)) {
            formattedMessageArray = (formattedMessageArray || []).concat(msgArray);
          }

          if (Array.isArray(formattedMessageArray) && formattedMessageArray.length > 0) {
            var formattedMessage = formattedMessageArray.join('<br/>');
            notificationOptions = _objectSpread(_objectSpread({}, notificationOptions), {}, {
              message: formattedMessage
            });
          }
        } // When "onModalDialog" option is true and target is not defined then render toast on top of modal dialog container


        if (notificationOptions.onModalDialog && !notificationOptions.target && this.isOnModalDialog) {
          notificationOptions = _objectSpread(_objectSpread({}, notificationOptions), {}, {
            drag: false,
            target: D3_MODAL_TARGET_CLASS,
            displayMode: 2,
            // will replace the existing toast from modal
            id: 'inline-modal-toast' // to identify the toasts on modals for replacement

          });
        } // title should be always be a string || array of strings, if not delete the title option to avoid script error


        if (!notificationOptions.title) {
          delete notificationOptions.title;
        } // Adding Read More button when the message length more than given length and target is not defined


        var _notificationOptions2 = notificationOptions,
            message = _notificationOptions2.message,
            target = _notificationOptions2.target,
            readMoreButtonText = _notificationOptions2.readMoreButtonText;
        var readMoreButtonLabel = readMoreButtonText || this.defaultOptions.readMoreButtonText;
        var isInlineToast = !!(target && target !== '');

        if (!isInlineToast && message && message.length > DEFAULT_MESSAGE_LENGTH) {
          notificationOptions.class = "".concat(D3_NOTIFICATION_CLASS, " read-more");
          notificationOptions.buttons = [// @ts-ignore - iziToast typing is incorrect.
          [toastReadMoreTemplate(readMoreButtonLabel), this.displayMore]];
        } // overriding the toast events


        var _notificationOptions3 = notificationOptions,
            onOpening = _notificationOptions3.onOpening;

        if (onOpening && typeof onOpening === 'function') {
          notificationOptions.onOpening = function (settings, toast) {
            _this2.onOpening(settings, toast);

            onOpening(settings, toast);
          };
        }
      }

      return notificationOptions;
    }
  }, {
    key: "displayMore",
    value: function displayMore(_, toast) {
      var buttonsContainer = toast.querySelector('div.iziToast-buttons');
      var moreButton = toast.querySelector('div.iziToast-buttons>button.read-more-btn');

      if (buttonsContainer && moreButton) {
        toast.classList.toggle('read-more');
        moreButton.classList.toggle('hidden');
        buttonsContainer.classList.toggle('hidden');
      }
    }
  }, {
    key: "setStatusIcon",
    value: function setStatusIcon(instance, toast) {
      var color = instance.color;
      var fontIcon = getStatusIcon(color);
      var iconEl = toast.querySelector('.iziToast-icon');

      if (iconEl && fontIcon) {
        iconEl.insertAdjacentHTML('beforeend', fontIcon); // TODO: this is typed as string[]
      }
    }
  }, {
    key: "setAriaAttributes",
    value: function setAriaAttributes(instance, toast) {
      // Fixing Axe issue, button should have some content and screen reader detection.
      if (toast.parentElement) {
        toast.parentElement.setAttribute('role', 'complementary'); // since toast renders outside of landmark region.
      }

      toast.setAttribute('role', instance.close ? 'alertdialog' : 'alert');
      toast.setAttribute('tabindex', 0);
      var closeButton = toast.querySelector('button.iziToast-close');
      var closeFontIcon = NotificationServiceIcons.close;

      if (closeButton && closeFontIcon) {
        closeButton.insertAdjacentHTML('beforeend', closeFontIcon); // TODO: this is typed as string[]

        if (instance.closeButtonText) {
          closeButton.setAttribute('aria-label', instance.closeButtonText);
        }
      }
    }
  }, {
    key: "onOpening",
    value: function onOpening(instance, toast) {
      this.setStatusIcon(instance, toast);
      this.setAriaAttributes(instance, toast); // Adding additional class with toast instance position to show toasts at right positions.
      // As per the library, if the navigator.usergent has Mobile or window innerwidth < 568 then it automatically displays in center position.

      var toastWrapperEl = document.querySelector('.iziToast-wrapper');
      var positionCls = "toast-position-".concat(instance.position);

      if (toastWrapperEl && toastWrapperEl.classList && !toastWrapperEl.classList.contains(positionCls)) {
        toastWrapperEl.classList.add("toast-position-".concat(instance.position));
      }
    }
  }, {
    key: "warning",
    value: function warning(notificationOptions) {
      var parsedOptions = this.parseToastConfig(notificationOptions);
      this.toaster.warning(_objectSpread(_objectSpread({
        timeout: false
      }, parsedOptions), {}, {
        color: NotificationType.Warning
      }));
    }
  }, {
    key: "error",
    value: function error(notificationOptions) {
      var parsedOptions = this.parseToastConfig(notificationOptions);
      this.toaster.error(_objectSpread(_objectSpread({
        timeout: this.defaultOptions.defaultErrorTimeout
      }, parsedOptions), {}, {
        color: NotificationType.Error
      }));
    }
  }, {
    key: "info",
    value: function info(notificationOptions) {
      var parsedOptions = this.parseToastConfig(notificationOptions);
      this.toaster.info(_objectSpread(_objectSpread({
        timeout: false
      }, parsedOptions), {}, {
        color: NotificationType.Info
      }));
    }
  }, {
    key: "success",
    value: function success(notificationOptions) {
      var parsedOptions = this.parseToastConfig(notificationOptions);
      this.toaster.success(_objectSpread(_objectSpread({
        timeout: this.defaultOptions.defaultSuccessTimeout
      }, parsedOptions), {}, {
        color: NotificationType.Success
      }));
    }
    /**
     * To destroy all the toasts or given type(s)
     * @param {string | string[]} byType
     */

  }, {
    key: "destroy",
    value: function destroy(byType) {
      var _this3 = this;

      if (byType) {
        var toastSelector;

        if (_isString(byType)) {
          toastSelector = ".iziToast.".concat(D3_NOTIFICATION_CLASS, ".iziToast-color-").concat(byType);
        } else {
          var toasterTypeSelectors = byType.map(function (type) {
            return ".iziToast.".concat(D3_NOTIFICATION_CLASS, ".iziToast-color-").concat(type);
          });
          toastSelector = toasterTypeSelectors.join(',');
        }

        var toasts = document.querySelectorAll(toastSelector);

        if (toasts && toasts.length > 0) {
          Array.from(toasts).forEach(function (toast) {
            return _this3.hide(toast);
          });
        }

        return;
      }

      this.toaster.destroy();
    }
    /**
     * Toast hide, will toast and its parent node from DOM
     * @param { HTML Node } toast
     */

  }, {
    key: "hide",
    value: function hide(toast) {
      removeNode(toast);
    }
  }, {
    key: "count",
    get: function get() {
      return document.querySelectorAll(".iziToast.".concat(D3_NOTIFICATION_CLASS, ":not(.iziToast-closing)")).length;
    }
  }, {
    key: "types",
    get: function get() {
      return NotificationType;
    }
  }, {
    key: "isOnModalDialog",
    get: function get() {
      return !!document.querySelector(D3_MODAL_TARGET_CLASS);
    }
  }]);

  return NotificationService;
}();

function getNotificationService() {
  window.d3 = window.d3 || {};
  window.d3.NotificationService = window.d3.NotificationService || new NotificationService();
  return window.d3.NotificationService;
}

export default getNotificationService();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/services/notifications/NotificationService.js
// module id = 552
// module chunks = 0